import { Box, Skeleton } from '@chakra-ui/react';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import React from 'react';

import { useGetUserActiveCreditFacilitiesQuery } from 'types/dashboard-core-gqlTypes.generated.d';

import { dashboardRoutePadding } from 'packages/common-frontend/constants';
import { VerificationHistoryTable } from 'packages/verifications/ui/VerificationHistoryTable';

export const VerificationHistoryRoute: React.FC = withLDConsumer()(
  ({ flags }) => {
    const { data: userData } = useGetUserActiveCreditFacilitiesQuery({
      variables: {
        creditFacilitySlugsToHide: flags?.creditFacilitySlugsToHide ?? [],
      },
    });

    if (!userData || !userData.user) {
      return (
        <Skeleton data-testid="loading-verification-history" height="600px" />
      );
    }

    return (
      <Box padding={dashboardRoutePadding}>
        <VerificationHistoryTable
          organizationId={userData.user.organizationId}
        />
      </Box>
    );
  },
);
